import React, { useState } from "react";
import { CampaignsPage } from "./CampaignsPage";
import { CampaignBoard } from "./CampaignBoard";
import { portalClient } from "./portalClient";

// Booking Tracker opens on the list of campaigns; picking one shows just that
// site's campaign. Local state rather than a route, matching how the rest of
// the app does list -> detail (see sites/SitesPage.js), and keeping the whole
// portal reachable from App.js through this one component.
export function TrackingBoard() {
  const [campaignId, setCampaignId] = useState(null);

  if (campaignId)
    return (
      <CampaignBoard
        client={portalClient}
        campaignId={campaignId}
        onBack={() => setCampaignId(null)}
      />
    );

  return <CampaignsPage onSelect={setCampaignId} />;
}
